import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipInterest = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormLabel sx={{ color: 'text.primary' }}><b>Juros (%)</b></FormLabel>
            <TooltipPopover>
                <ul>
                    <li>Forma de compensação pelo atraso no pagamento, calculada sobre o valor da dívida. </li>
                    <li>Incidem por dia de atraso e podem ter um limite legal, como 1% ao mês. </li>
                    <li>Não precisam ser explicitamente previstos no contrato, pois são previstos por lei. </li>
                </ul>
                <p>
                    O preenchimento da porcentagem do juros na criação da fatura tem o objetivo de registro.
                    O Produttivo não calcula automaticamente o valor a ser pago em uma fatura atrasada.
                </p>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipInterest;